module.exports = __webpack_public_path__ + "img/potion_img_06.24956bf5.png";